import { put } from 'redux-saga/effects';
import { call, debounce, select } from 'typed-redux-saga';
import { logisticsActionCreators, LogisticsActionKeys, UpdateLoad } from '..';
import { IState } from '../..';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { updateLoad } from '../logisticsApi';
import { getCurrentLoad } from '../logisticsSelectors';

function* updateLoadSaga(action: UpdateLoad) {
  const currentLoad = yield* select((state: IState) => getCurrentLoad(state, action.payload.loadNumber));
  if (currentLoad) {
    const updates = yield* select(
      (state: IState) => state.logistics.optimisticLoadUpdates[action.payload.loadNumber] ?? {}
    );
    const response = yield* call(updateLoad, { ...currentLoad, ...updates });

    if (response.requestFailed) {
      yield showFailedRequestDialog(response);
    } else if (response.value) {
      yield processMessages(response.value);

      if (response.value.value) {
        yield put(logisticsActionCreators.setLoad(response.value.value));
      }
    }
  }
}

export function* watchUpdateLoad() {
  //  yield takeEvery(LogisticsActionKeys.UPDATE_LOAD, updateLoadSaga);
  yield debounce(2000, LogisticsActionKeys.UPDATE_LOAD, updateLoadSaga);
}
